<template>
    <v-dialog
        v-model="$store.state.order.edt"
        max-width="1366px"
        transition="dialog-transition"
    >
        <v-container
            class="container"
            fluid
            style="margin-top: 0px; padding-top: 0px"
        >
            <SiteReadings v-if="siteData" ref="siteRef" />

            <v-card>
                <v-toolbar dense dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text"
                        >View Order</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn icon @click="$store.state.order.edt = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-toolbar>
                <v-row class="mx-5 my-4">
                    <div class="tm">
                        <v-combobox
                            v-model="type"
                            :items="types"
                            class="mt-3"
                            :item-text="'Type'"
                            :item-value="'id'"
                            label="Station Type"
                            auto-select-first
                            hide-details
                            dense
                        ></v-combobox>
                    </div>
                    <div class="tm">
                        <v-text-field
                            v-model="orderID"
                            label="OrderID"
                            v-if="$store.state.editedOrder.id"
                            disabled
                            hide-details
                            dense
                            class="mx-3"
                        ></v-text-field>
                    </div>
                    <div class="tm">
                        <v-text-field
                            v-model="editedItem.DateOrdered"
                            label="Order Date"
                            class="mx-3"
                            hide-details
                            dense
                            disabled
                        ></v-text-field>
                    </div>
                    <div class="tm">
                        <v-text-field
                            v-model="editedItem.TimeOrdered"
                            label="Order Time"
                            class="mx-3"
                            hide-details
                            dense
                            disabled
                        ></v-text-field>
                    </div>
                </v-row>
                <v-form ref="form" lazy-validation>
                    <v-row class="mx-5">
                        <div class="tm">
                            <v-combobox
                                required
                                v-model="editedItem.Station"
                                :items="filteredStations"
                                :item-text="'Name'"
                                :item-value="'id'"
                                label="Station"
                                :rules="[v => !!v || 'Station is required']"
                                class="mx-3"
                                auto-select-first
                                @change="getStationInfo()"
                            ></v-combobox>
                        </div>
                        <div class="tm">
                            <v-combobox
                                required
                                v-model="editedItem.Customer"
                                :items="customers"
                                :item-text="'Name'"
                                :item-value="'id'"
                                label="Customer"
                                @change="updateCodes()"
                                :rules="[v => !!v || 'Customer is required ']"
                                class="mx-3"
                                auto-select-first
                            ></v-combobox>
                        </div>
                        <div class="tm">
                            <v-combobox
                                required
                                v-model="editedItem.Terminal"
                                :items="terminals"
                                :item-text="'Name'"
                                :item-value="'id'"
                                :rules="[v => !!v || 'Terminal is required']"
                                label="Terminal"
                                @change="updateCodes()"
                                @click:append-outer="savePrimary"
                                append-outer-icon="mdi-content-save"
                                class="mx-3"
                                auto-select-first
                            ></v-combobox>
                        </div>
                        <div class="tm">
                            <v-combobox
                                required
                                v-model="editedItem.Supplier"
                                :items="suppliers"
                                :item-text="'Supplier'"
                                :rules="[v => !!v || 'Supplier is required']"
                                :item-value="'id'"
                                label="Supplier"
                                @change="updateCodes()"
                                class="mx-3"
                                auto-select-first
                            ></v-combobox>
                        </div>
                    </v-row>
                    <v-row class="mx-5">
                        <div class="tm">
                            <v-alert
                                dense
                                type="error"
                                v-if="SBusinessInterruption"
                                >This station is marked as a business
                                interruption.</v-alert
                            >
                        </div>
                        <div class="tm"></div>
                        <div class="tm">
                            <v-alert
                                dense
                                type="error"
                                v-if="TBusinessInterruption"
                                >This terminal is marked as a business
                                interruption.</v-alert
                            >
                        </div>
                        <div class="tm"></div>
                    </v-row>
                <v-row class="mx-5">
                    <div class="tm">
                        <v-text-field
                            label="Ship To"
                            id="ShipTo"
                            v-model="editedItem.ShipTo"
                            :value="editedItem.ShipTo"
                        ></v-text-field>
                    </div>
                    <v-checkbox
                        class="mx-3"
                        large
                        label="Validate"
                        v-model="editedItem.Validate"
                    ></v-checkbox>
                    <v-checkbox
                        disabled
                        class="mx-3"
                        large
                        label="Split CK"
                        v-model="editedItem.SplitApprovedCK"
                    ></v-checkbox>
                    <v-checkbox
                        class="mx-3"
                        large
                        label="No Allocation"
                        v-model="editedItem.NoAllocation"
                    ></v-checkbox>
                </v-row>
                <v-row class="mx-5">
                    <div class="tm">
                        <v-text-field
                            class="mx-3"
                            label="Loading Number"
                            v-model="editedItem.LoadingNumber"
                        ></v-text-field>
                    </div>
                    <div class="tm12">
                        <v-text-field
                            label="Requested Date"
                            id="DateRequested"
                            :value="editedItem.DateRequested"
                            v-mask="'####/##/## ##:##'"
                            :rules="[v => !!v || 'Date Requested is required']"
                            required
                            type="tel"
                        ></v-text-field>
                    </div>
                    <div class="tm12">
                        <v-text-field
                            v-model="editedItem.RetainHrs"
                            id="RetainHrs"
                            v-if="this.type.id != 1"
                            v-mask="'##:##'"
                            label="RetainHrs"
                            :rules="[v => !!v || 'RetainHrs is required']"
                            required
                            class="mx-1"
                        ></v-text-field>
                    </div>
                    <div class="tm12">
                        <v-text-field
                            label="ROHrs Date"
                            id="ROHrsDate"
                            v-if="this.type.id != 1"
                            :value="editedItem.ROHrsDate"
                            v-mask="'####-##-##'"
                            class="ml-1"
                            :rules="[v => !!v || 'ROHrsDate is required']"
                            required
                            type="tel"
                        ></v-text-field>
                    </div>
                    <div class="tm12">
                        <v-text-field
                            label="ROHrs Time"
                            id="ROHrsTime"
                            v-if="this.type.id != 1"
                            v-model="editedItem.ROHrsTime"
                            v-mask="'##:##'"
                            :rules="[v => !!v || 'ROHrsTime is required']"
                            required
                            class="mx-1"
                        ></v-text-field>
                    </div>
                    <div class="tm12">
                        <v-text-field
                            class="mx-3"
                            label="Created By"
                            v-model="editedItem.Username"
                            disabled
                        ></v-text-field>
                    </div>
                </v-row>
            </v-form>
                <v-row class="mx-5">
                    <div class="tm2">
                        <v-combobox
                            v-model="editedItem.OrderType"
                            :items="order_types"
                            :item-text="'OrderType'"
                            :item-value="'OrderTypeID'"
                            label="Order Type"
                            class="mx-3"
                            auto-select-first
                        ></v-combobox>
                    </div>
                    <div class="tm2">
                        <v-combobox
                            v-model="editedItem.SplitType"
                            :items="split_types"
                            :item-text="'SplitTypeName'"
                            :item-value="'SplitTypeID'"
                            label="Split Type"
                            class="mx-3"
                            auto-select-first
                        ></v-combobox>
                    </div>
                    <div class="tm2">
                        <v-combobox
                            v-model="editedItem.NoLoadType"
                            :items="no_load_types"
                            :item-text="'NoLoadTypeName'"
                            :item-value="'NoLoadTypeID'"
                            label="No Load Type"
                            class="mx-3"
                            auto-select-first
                        ></v-combobox>
                    </div>
                </v-row>
                <v-row
                    class="mx-5"
                    v-if="$store.state.editedOrder.destiny == 1"
                >
                    <div class="tm65">
                        <v-row>
                            <div class="tm5">
                                <v-textarea
                                    v-model="editedItem.DispatchComments"
                                    label="Dispatch Comments"
                                    class="mx-3"
                                    rows="3"
                                    no-resize
                                ></v-textarea>
                            </div>
                            <div class="tm5">
                                <v-textarea
                                    class="mx-3"
                                    rows="3"
                                    label="Special Instructions"
                                    v-model="editedItem.SpecialInstructions"
                                    no-resize
                                ></v-textarea>
                            </div>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    class="mx-3"
                                    label="Shift Detail"
                                    v-model="editedItem.ShiftDetail"
                                    disabled
                                ></v-text-field>
                                <v-text-field
                                    class="mx-3"
                                    label="Driver"
                                    v-model="editedItem.Driver"
                                    disabled
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    class="mx-3"
                                    label="Shift Date"
                                    v-model="editedItem.ShiftDate"
                                    disabled
                                ></v-text-field>
                                <v-text-field
                                    class="mx-3"
                                    label="Trailer"
                                    v-model="editedItem.Trailer"
                                    disabled
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    class="mx-3"
                                    label="Shift"
                                    v-model="editedItem.Shift"
                                    disabled
                                ></v-text-field>
                                <v-text-field
                                    class="mx-3"
                                    label="Truck"
                                    v-model="editedItem.Truck"
                                    disabled
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="tm35">
                        <v-data-table
                            :headers="headers"
                            :items="orderProducts"
                            item-key="id"
                            class="elevation-1 ml-2"
                            dense
                            height="200px"
                            hide-default-footer
                            disable-pagination
                            disable-sort
                        >
                            <template v-slot:top>
                                <v-toolbar dark color="secondary" dense>
                                    <v-spacer />
                                    <v-toolbar-title class="white--text"
                                        >Order Detail</v-toolbar-title
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn large icon @click="updateCodes()"
                                        ><v-icon>mdi-reload</v-icon></v-btn
                                    >
                                    <v-btn
                                        :disabled="
                                            editedItem.isSpecific > 0 &&
                                                editedItem.ShiftDetail > 0
                                        "
                                        large
                                        icon
                                        @click="addRow()"
                                        ><v-icon>mdi-plus</v-icon></v-btn
                                    >
                                </v-toolbar>
                            </template>
                            <template v-slot:item.Product="{ item, index }">
                                <v-combobox
                                    v-model="item.Product"
                                    :items="products"
                                    :item-text="'Product'"
                                    :item-value="'ProductID'"
                                    auto-select-first
                                    dense
                                    :disabled="
                                        editedItem.isSpecific > 0 &&
                                            editedItem.ShiftDetail > 0
                                    "
                                    class="pdr"
                                    @change="getCode(item, index)"
                                ></v-combobox>
                            </template>
                            <template v-slot:item.Quantity="{ item }">
                                <v-text-field
                                    v-model="item.Quantity"
                                    :rules="orderRules"
                                    type="number"
                                    dense
                                    class="pdr"
                                >
                                </v-text-field>
                            </template>
                            <template v-slot:item.ProductCode="{ item }">
                                <v-text-field
                                    v-model="item.ProductCode"
                                    dense
                                    class="pdr"
                                >
                                </v-text-field>
                            </template>
                            <template v-slot:item.Delete="{ item }">
                                <v-btn
                                    color="secondary"
                                    icon
                                    dark
                                    :disabled="
                                        editedItem.isSpecific > 0 &&
                                            editedItem.ShiftDetail > 0
                                    "
                                    @click="searchIndex(item)"
                                >
                                    <v-icon>mdi-minus</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </div>
                    <v-row class="ma-5">
                        <div v-if="isModal != 'true'">
                            <v-btn
                                dark
                                color="secondary"
                                class="mx-3 white--text"
                                @click="validate()"
                            >
                                Save 
                                <v-icon right dark>mdi-content-save</v-icon>
                            </v-btn>

                            <v-btn
                                v-if="$store.state.orderDialog == false"
                                exact
                                dark
                                color="secondary"
                                class="mr-3 white--text"
                                @click="cancel()"
                            >
                                Close
                                <v-icon right dark>mdi-close</v-icon>
                            </v-btn>
                            <v-btn
                                v-else
                                exact
                                dark
                                color="secondary"
                                class="mr-3 white--text"
                                @click="$store.state.orderDialog = false"
                            >
                                Close
                                <v-icon right dark>mdi-close</v-icon>
                            </v-btn>
                        </div>

                        <v-row class="mx-5">
                            <v-btn
                                :disabled="
                                    editedItem.Station.BusinessInterruption
                                "
                                color="secondary"
                                class="ma-5 white--text"
                                @click="replicateOrder()"
                                v-if="!replicateOrd"
                            >
                                Replicate
                                <v-icon right dark>mdi-content-copy</v-icon>
                            </v-btn>
                            <v-btn
                                v-if="!replicateOrd"
                                exact
                                dark
                                color="secondary"
                                class="ma-5 white--text"
                                @click="confirmDeleteOrder()"
                            >
                                Delete
                                <v-icon right dark>mdi-delete</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="!replicateOrd"
                                color="secondary"
                                class="ma-5 white--text"
                                @click="validate()"
                                :disabled="
                                    editedItem.Station.BusinessInterruption
                                "
                            > 
                                Save 
                                <v-icon right dark>mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn
                                v-else
                                color="secondary"
                                class="ma-5 white--text"
                                @click="validateDuplicateOrder()"
                                :disabled="
                                    editedItem.Station.BusinessInterruption
                                "
                            > 
                                Confirm Save
                                <v-icon right dark>mdi-content-save</v-icon>
                            </v-btn>
                        </v-row>
                    </v-row>

                    <!--Row Order Detail-->
                </v-row>
                <v-row class="mx-5" v-else>
                    <v-row>
                        <div class="tm5">
                            <v-textarea
                                v-model="editedItem.DispatchComments"
                                label="Dispatch Comments"
                                class="mx-3"
                                rows="4"
                                no-resize
                            ></v-textarea>
                        </div>
                        <div class="tm5">
                            <v-textarea
                                class="mx-3"
                                rows="4"
                                label="Special Instructions"
                                v-model="editedItem.SpecialInstructions"
                                no-resize
                            ></v-textarea>
                        </div>
                    </v-row>
                    <div class="tm5">
                        <v-row>
                            <v-col>
                                <v-text-field
                                    class="mx-3"
                                    label="Shift Detail"
                                    v-model="editedItem.ShiftDetail"
                                    disabled
                                ></v-text-field>
                                <v-text-field
                                    class="mx-3"
                                    label="Driver"
                                    v-model="editedItem.Driver"
                                    disabled
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    class="mx-3"
                                    label="Shift Date"
                                    v-model="editedItem.ShiftDate"
                                    disabled
                                ></v-text-field>
                                <v-text-field
                                    class="mx-3"
                                    label="Trailer"
                                    v-model="editedItem.Trailer"
                                    disabled
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    class="mx-3"
                                    label="Shift"
                                    v-model="editedItem.Shift"
                                    disabled
                                ></v-text-field>
                                <v-text-field
                                    class="mx-3"
                                    label="Truck"
                                    v-model="editedItem.Truck"
                                    disabled
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                    <v-row class="ma-5">
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="isModal != 'true'"
                            dark
                            color="secondary"
                            class="mx-3 white--text"
                            @click="validate()"
                        >
                            Save
                            <v-icon right dark>mdi-content-save</v-icon>
                        </v-btn>
                        <v-btn
                            v-if="isModal != 'true'"
                            exact
                            dark
                            color="secondary"
                            class="mr-3 white--text"
                            @click="cancel()"
                        >
                            Close
                            <v-icon right dark>mdi-close</v-icon>
                        </v-btn>
                        <v-row
                            class="mx-5"
                            v-if="this.$store.state.editedOrder.id"
                        >
                            <v-spacer />
                            <v-btn
                                dark
                                color="secondary"
                                class="ma-5 white--text"
                                @click="copyOrdCheck()"
                            >
                                Replicate3
                                <v-icon right dark>mdi-content-copy</v-icon>
                            </v-btn>
                            <v-btn
                                exact
                                dark
                                color="secondary"
                                class="ma-5 white--text"
                                @click="confirmDeleteOrder()"
                            >
                                Delete
                                <v-icon right dark>mdi-delete</v-icon>
                            </v-btn>
                        </v-row>
                    </v-row>
                    <!--Row Order Detail-->
                </v-row>
            </v-card>

            <v-dialog v-model="dialog" max-width="400px">
                <v-card>
                    <v-toolbar color="primary" dense>
                        <v-spacer />
                        <v-toolbar-title class="white--text">
                            Are you sure you want to save
                            changes?</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-container class="px-10 py-5">
                        <v-row>
                            <v-btn color="success" @click="editOrder()"
                                >Yes</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn color="red" @click="dialog = false"
                                >Cancel</v-btn
                            >
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        </v-container>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import moment from 'moment';
import SiteReadings from '../Readings/SiteReadings.vue';
import ConfirmDialogue from './../../ConfirmDialogue.vue';

export default {
    name: 'OrdersForm',
    props: ['isModal', 'siteData', 'back'],

    components: {
        SiteReadings,
        ConfirmDialogue
    },

    directives: {
        mask
    },
    data: function() {
        return {
            dialog: false,
            orderID: this.$store.state.editedOrder.id,
            today: moment(),
            valid: true,
            Special: 0,
            defaultItem: {
                Station: '',
                Customer: '',
                Terminal: '',
                Supplier: '',
                LoadingNumber: '',
                DateRequested: '',
                SpecialInstructions: '',
                DispatchComments: '',
                DateOrdered: '',
                TimeOrdered: '',
                ShiftDetail: '',
                Driver: '',
                Truck: '',
                Trailer: '',
                Shift: '',
                ShiftDate: '',
                onPrice: false,
                SplitApprovedCK: false,
                NoAllocation: false,
                orderProducts: {
                    Product: [],
                    Quantity: []
                },
                SplitType: {
                    SplitTypeName: '',
                    SplitTypeID: null
                },
                NoLoadType: {
                    NoLoadTypeName: '',
                    NoLoadTypeID: null
                },
                OrderType: {
                    OrderType: '',
                    OrderTypeID: null
                }
            },
            headers: [
                { text: 'Product', value: 'Product', width: '50%' },
                { text: 'Product Code', value: 'ProductCode', width: '20%' },
                { text: 'Quantity', value: 'Quantity', width: '20%' },
                { text: 'Delete', value: 'Delete', width: '10%' }
            ],
            editedItem: {
                isSpecific: 0,
                Station: '',
                Customer: '',
                editID: 0,
                Terminal: '',
                Order: [],
                Supplier: '',
                LoadingNumber: '',
                DateRequested: '',
                SpecialInstructions: '',
                DispatchComments: '',
                DateOrdered: '',
                TimeOrdered: '',
                ShiftDetail: '',
                Driver: '',
                Truck: '',
                Trailer: '',
                Shift: '',
                ShiftDate: '',
                Username: '',
                validate: false,
                SplitApprovedCK: false,
                NoAllocation: false,
                ROHrsTime: '',
                RetainHrs: '',
                ROHrsDate: '',
                SplitType: {
                    SplitTypeName: '',
                    SplitTypeID: null
                },
                NoLoadType: {
                    NoLoadTypeName: '',
                    NoLoadTypeID: null
                },
                OrderType: {
                    OrderType: '',
                    OrderTypeID: null
                }
            },
            SBusinessInterruption: false,
            TBusinessInterruption: false,
            Cont: 1,
            orderProducts: [],
            deletedProducts: [],
            types: [
                { id: 1, Type: 'Contracted' },
                { id: 2, Type: 'Private' },
                { id: 3, Type: 'Interplant' }
            ],
            replicateOrd:false,
            type: [],
            stations: [],
            customers: [],
            terminals: [],
            suppliers: [],
            split_types: [],
            no_load_types: [],
            order_types: [],
            rows: [0],
            rowCount: 0,
            RTHrs:null,
            products: [],
            orderRules: [
                v => !!v || 'This field is required',
                v => (v && v <= 60000) || 'Amount should not be above 60,000'
            ],
            menu: false,
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ]
        };
    },
    computed: {
        orderTot() {
            return this.orderProducts.reduce(getOrderTotal, 0);

            function getOrderTotal(total, item) {
                var q = parseInt(item.Quantity);
                if (isNaN(q)) {
                    return total + 0;
                } else {
                    return total + q;
                }
            }
        },
        filteredStations() {
            return this.stations.filter(i => {
                return !this.type || i.StationType == this.type.id;
            });
        }
    },
    mounted() {
        this.orderProducts.length = 0;
        this.loadDataToday();
        this.loadStations();
        this.loadCustomers();
        this.loadTerminals();
        this.loadSuppliers();
        this.loadOrderData();
        this.loadSplitTypes();
        this.loadNoLoadTypes();
        this.loadOrderTypes();
        this.loadAllProducts();
    },
    watch: {
        '$store.state.editedOrder.id': function() {
            (this.orderProducts = []),
                (this.orderID = this.$store.state.editedOrder.id),
                console.log(this.$store.state.editedOrder.id);
            this.loadOrderData();
        },
        'editedItem.Station': function() {
            console.log('Station Change');
            if (this.editedItem.Station.BusinessInterruption == 1) {
                this.SBusinessInterruption = true;
            } else {
                this.SBusinessInterruption = false;
            }
        },
        'editedItem.Terminal': function() {
            console.log('Terminal Change');
            if (this.editedItem.Terminal.BusinessInterruption == 1) {
                this.TBusinessInterruption = true;
            } else {
                this.TBusinessInterruption = false;
            }
        },
        siteData: function() {
            if (this.siteData) {
                console.log(this.siteData);
                this.editedItem.Station = {
                    id: this.siteData.StationID,
                    Name: this.siteData.StationName
                };
                this.getStationInfo();
            }
        }
    },

    methods: {
        savePrimary: function() {
            var str = this.$store;
            var params = {
                ContractTerminal: this.editedItem.Terminal.id
            };
            if (
                this.editedItem.Station.id == null ||
                this.editedItem.Terminal.id == null
            ) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Select Terminal and Station'
                });
            } else {
                axios
                    .put('station/' + this.editedItem.Station.id, params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Primary Terminal saved successfully'
                        });
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
        },
        searchIndex: function(itm) {
            console.log(this.orderProducts);
            const index = this.orderProducts.findIndex(elm => {
                return elm.productDetailID == itm.productDetailID;
            });
            this.deleteRow(index);
        },
        loadDataToday: function() {
            if (
                this.$store.state.editedOrder.destiny == 1 ||
                this.$store.state.editedOrder.destiny == 2
            ) {
                this.editedItem.DateRequested = this.editedItem.DateOrdered = moment(
                    new Date()
                ).format('YYYY/MM/DD');
            }
            console.log(this.editedItem.DateRequested);
        },
        loadStations: function() {
            this.$store.state.isLoading = true;
            axios
                .get('station/active')
                .then(response => {
                    this.stations = response.data.data;
                    console.log(this.stations);
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadCustomers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active')
                .then(response => {
                    this.customers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadTerminals: function() {
            this.$store.state.isLoading = true;
            axios
                .get('terminal/active')
                .then(response => {
                    this.terminals = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadSuppliers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('supplier/active')
                .then(response => {
                    this.suppliers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadSplitTypes: function() {
            axios
                .get('split-type')
                .then(response => {
                    this.split_types = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadNoLoadTypes: function() {
            axios
                .get('no-load-type')
                .then(response => {
                    this.no_load_types = response.data;
                    console.log(this.no_load_types);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadOrderTypes: function() {
            axios
                .get('order-type')
                .then(response => {
                    this.order_types = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getLoadingNumber: function() {
            var parms = {
                Terminal: this.editedItem.Terminal.id,
                Supplier: this.editedItem.Supplier.id,
                Customer: this.editedItem.Customer.id
            };
            console.log('Here', parms);
            axios
                .post('product-code-number/loading-number', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.editedItem.LoadingNumber = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadOrderData: function() {
            this.$store.state.isLoading = true;
            this.editedItem.DateOrdered = moment(new Date()).format(
                'YYYY/MM/DD'
            );
            this.editedItem.TimeOrdered = moment(new Date()).format('HH:mm');
            if (this.siteData) {
                console.log(this.siteData);
                this.editedItem.Station = {
                    id: this.siteData.StationID,
                    Name: this.siteData.StationName
                };
                this.getStationInfo();
            }
            if (this.orderID != null) {
                console.log('loading New order');
                axios
                    .get('order/info/' + this.orderID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log(response.data.data[0]);
                        this.editedItem.isSpecific =
                            response.data.data[0].isSpecific;
                        this.editedItem.OrderID = response.data.data[0].OrderID;
                        this.editedItem.Station = {
                            id: response.data.data[0].StationID,
                            Name: response.data.data[0].Station
                        };
                        this.editedItem.Customer = {
                            id: response.data.data[0].CustomerID,
                            Name: response.data.data[0].Customer
                        };

                        //if (response.data.data[0].isContract) {
                        //    this.editedItem.Terminal = {
                        //        id: response.data.data[0].ContractTerminal,
                        //        Name: response.data.data[0].ContractTerminalName
                        //    };
                        //}
                        //else {
                        this.editedItem.Terminal = {
                            id: response.data.data[0].TerminalID,
                            Name: response.data.data[0].Terminal
                        };
                        //}
                        this.editedItem.Supplier = {
                            id: response.data.data[0].SupplierID,
                            Supplier: response.data.data[0].Supplier
                        };
                        this.editedItem.OrderType = {
                            OrderTypeID: response.data.data[0].OrderTypeID,
                            OrderType: response.data.data[0].OrderType
                        };
                        this.editedItem.SplitType = {
                            SplitTypeID: response.data.data[0].SplitTypeID,
                            SplitTypeName: response.data.data[0].SplitType
                        };
                        this.editedItem.NoLoadType = {
                            NoLoadTypeID: response.data.data[0].NoLoadTypeID,
                            NoLoadTypeName: response.data.data[0].NoLoadType
                        };
                        var idx = this.types.findIndex(x => {
                            return x.id == response.data.data[0].StationType;
                        });

                        this.type = this.types[idx];

                        this.editedItem.LoadingNumber =
                            response.data.data[0].LoadingNumber;
                        this.editedItem.DateRequested =
                            response.data.data[0].DateRequested;

                        this.editedItem.ROHrsTime =
                            response.data.data[0].ROHrsTime;
                        this.editedItem.ROHrsDate =
                            response.data.data[0].ROHrsDate;
                        this.editedItem.RetainHrs =
                            response.data.data[0].RetainHrs;

                        this.editedItem.SpecialInstructions =
                            response.data.data[0].SpecialInstructions;

                        this.editedItem.OrderStatus =
                            response.data.data[0].OrderStatus;
                        this.editedItem.DateOrdered =
                            response.data.data[0].DateOrdered;
                        this.editedItem.TimeOrdered =
                            response.data.data[0].TimeOrdered;
                        this.editedItem.DispatchComments =
                            response.data.data[0].DispatchComments;
                        this.editedItem.ShiftDetail =
                            response.data.data[0].ShiftDetail;
                        this.editedItem.ShiftDate =
                            response.data.data[0].ShiftDate;
                        this.editedItem.SplitApprovedCK =
                            response.data.data[0].SplitApprovedCK;
                        this.editedItem.Shift = response.data.data[0].Shift;
                        this.editedItem.Driver = response.data.data[0].Driver;
                        this.editedItem.Trailer = response.data.data[0].Trailer;
                        this.editedItem.Truck = response.data.data[0].Truck;
                        this.editedItem.Username =
                            response.data.data[0].Username;
                        this.editedItem.ShipTo = response.data.data[0].ShipTo;
                        this.editedItem.Validate =
                            response.data.data[0].Validate;
                        this.editedItem.NoAllocation =
                            response.data.data[0].NoAllocation;
                        this.editedItem.ROHrsTime =
                            response.data.data[0].ROHrsTime;
                        this.editedItem.RetainHrs =
                            response.data.data[0].RetainHrs;

                        await axios
                            .get('order-detail/order/' + this.orderID, {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            })
                            .then(response => {
                                for (const i in response.data.data) {
                                    console.log(response.data.data[i]);
                                    var product = {
                                        ProductID:
                                            response.data.data[i].ProductID,
                                        Product: response.data.data[i].Product,
                                        productDetailID:
                                            response.data.data[i].id,
                                        Quantity:
                                            response.data.data[i].Quantity,
                                        SpecificTrailerOnly:
                                            response.data.data[i]
                                                .SpecificTrailerOnly,
                                        ProductCode:
                                            response.data.data[i].ProductCode
                                    };

                                    this.orderProducts.push(product);
                                }
                                console.log(this.orderProducts);
                                this.loadProducts(this.editedItem.Station.id);
                            })
                            .catch(function(error) {
                                console.log(error);
                            });

                        // this.getLoadingNumber();
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
            if (this.$store.state.editedOrder.StationID != null) {
                this.editedItem.Station = {
                    id: this.$store.state.editedOrder.StationID,
                    Name: this.$store.state.editedOrder.StationName
                };
                this.getStationInfo();
            }
            this.$store.state.isLoading = false;
        },

        calculateROHrs: function() {
            var mmt = moment().format('YYYY/MM/DD HH:mm');
            var roh = this.getMsk('ROHrsDate') + ' ' + this.getMsk('ROHrsTime');
            var start = new Date(mmt);
            var end = new Date(roh);

            // Calcular la diferencia en milisegundos
            var diifMs = end - start;

            // Convertir la diferencia a horas
            var diifHrs = diifMs / (1000 * 60 * 60);

            return diifHrs.toFixed(2);
        },
        getStationInfo: function() {
            //this.$store.state.isLoading = true;
            // var str = this.$store;
            axios
                .get('order/station/' + this.editedItem.Station.id)
                .then(response => {
                    this.editedItem.Customer = {
                        id: response.data.data[0].CustomerID,
                        Name: response.data.data[0].Customer
                    };
                    this.editedItem.Terminal = {
                        id: response.data.data[0].TerminalID,
                        Name: response.data.data[0].Terminal,
                        BusinessInterruption:
                            response.data.data[0].TBusinessInterruption
                    };
                    this.editedItem.Supplier = {
                        id: response.data.data[0].SupplierID,
                        Supplier: response.data.data[0].Supplier
                    };
                    this.editedItem.LoadingNumber =
                        response.data.data[0].LoadingNumber;
                    this.loadProducts(this.editedItem.Station.id);
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        addRow: function() {
            var newProduct = {
                ProductID: '',
                Product: '',
                ProductCode: '',
                Quantity: '',
                Cont: this.Cont
            };
            this.Cont++;
            this.orderProducts.push(newProduct);
        },
        deleteRow: function(row) {
            console.log(row);
            if (this.orderProducts[row].productDetailID != undefined)
                this.deletedProducts.push(
                    this.orderProducts[row].productDetailID
                );
            console.log(this.deletedProducts);
            this.orderProducts.splice(row, 1);
        },
        loadProducts: function(station) {
            this.$store.state.isLoading = true;
            var parms = {
                station: station
            };
            axios
                .post('product-station-priv/station', parms)
                .then(response => {
                    this.products = response.data;
                    if (this.products.length == 0) {
                        this.loadAllProducts();
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadAllProducts: function() {
            this.$store.state.isLoading = true;
            axios
                .get('product/active')
                .then(response => {
                    this.products = response.data.data;
                    if (this.editedItem.ShiftDetail > 0) {
                        this.products = this.products.filter(
                            x => x.SpecificTrailerOnly != 1
                        );
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        
        newOrder: function() {
            this.$store.state.isLoading = true;
            var SiteRTHrs = 0;
            var str = this.$store;
            var SiteROHrs = 0;
            if (this.siteData) {
                console.log('Products:');
                console.log(this.$refs.siteRef.products);
                for (var x in this.$refs.siteRef.products) {
                    if (this.$refs.siteRef.RTHrs[x]) {
                        if (x == 0) {
                            SiteRTHrs = this.$refs.siteRef.RTHrs[x];
                        }
                        if (this.$refs.siteRef.RTHrs[x] > SiteRTHrs) {
                            SiteRTHrs = this.$refs.siteRef.RTHrs[x];
                        }
                    }

                    if (this.$refs.siteRef.products[x].ROHrs) {
                        if (x == 0) {
                            SiteROHrs = this.$refs.siteRef.products[x].ROHrs;
                        }
                        if (this.$refs.siteRef.products[x].ROHrs < SiteROHrs) {
                            SiteROHrs = this.$refs.siteRef.products[x].ROHrs;
                        }
                    }
                }
                var day = new Date(
                    this.$refs.siteRef.readings[0].DateTime
                ).getTime();
                var ROTime = new Date(day + SiteROHrs * 3600000);
                var RTTime = new Date(day + SiteRTHrs * 3600000);
            } else {
                this.$store.state.editedOrder.destiny = 1;
            }
            var params = {
                Station: this.editedItem.Station.id,
                Customer: this.editedItem.Customer.id,
                Terminal: this.editedItem.Terminal.id,
                Supplier: this.editedItem.Supplier.id,
                DateRequested: this.getMsk('DateRequested'),
                TimeOrdered: this.editedItem.TimeOrdered,
                DateOrdered: this.editedItem.DateOrdered,
                LoadingNumber: this.editedItem.LoadingNumber,
                SpecialInstructions: this.editedItem.SpecialInstructions,
                DispatchComments: this.editedItem.DispatchComments,
                SplitTypeID: this.editedItem.SplitType.SplitTypeID,
                NoLoadTypeID: this.editedItem.NoLoadType.NoLoadTypeID,
                OrderTypeID: this.editedItem.OrderType.OrderTypeID,
                ReadyForDispatch: 1,
                RTHrs: SiteRTHrs,
                Validate: this.editedItem.Validate,
                isSpecific: this.Special,
                ROTime: moment(ROTime).format('YYYY-MM-DD HH:mm:ss'),
                RTTime: moment(RTTime).format('YYYY-MM-DD HH:mm:ss')
            };

            if (this.type.id != 1) {
                params.RetainHrs = this.getMsk('RetainHrs');
                params.ROHrsTime = this.getMsk('ROHrsTime');
                params.ROHrsDate = this.getMsk('ROHrsDate');
                params.ROHrs = this.ROHrs;
                params.RTHrs = this.RTHrs;
            }
            console.log(params);
            axios
                .post('order', params)
                .then(async response => {
                    console.log(response.data);
                    await this.newOrderDetails(response.data.OrderID);
                    this.$emit('refresh-lineup')
                    this.$store.state.order.edt = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        newOrderDetails:async function(OrderID) {
            this.$store.state.isLoading = true;
            console.log(this.orderProducts,'Order Product Duplicate Order')
                for (const i in this.orderProducts) {
                    
                    if (this.orderProducts[i].Product.ProductID != null) {
                        var params = {
                            OrderID: OrderID,
                            ProductType: this.orderProducts[i].Product.ProductID ,
                            ProductQuantity: this.orderProducts[i].Quantity,
                            DispatchedQuantity: this.orderProducts[i].Quantity
                        };
                      await this.createProductDetail(params);
                    }else{
                        var params = {
                            OrderID: OrderID,
                            ProductType: this.orderProducts[i].ProductID ,
                            ProductQuantity: this.orderProducts[i].Quantity,
                            DispatchedQuantity: this.orderProducts[i].Quantity
                        };
                        await this.createProductDetail(params);
                    }
                }
            this.$store.state.isLoading = false;
            // switch (this.$store.state.editedOrder.destiny) {
            //     case 1:
            //         this.$store.state.editedOrder.id = null;
            //         this.$store.state.editedOrder.destiny = null;
            //         if (this.back == true) {
            //             this.$store.state.order.view = true;
            //             this.$store.state.orderDialog = false;
            //         } else {
            //             this.$router.push('/dispatch/orders');
            //         }
            //         break;
            //     case 2:
            //         this.$store.state.editedOrder.id = null;
            //         this.$store.state.editedOrder.destiny = null;
            //         this.editedItem.SpecialInstructions = null;
            //         this.editedItem.DispatchComments = null;
            //         this.editedItem.OrderType = {
            //             OrderTypeID: null,
            //             OrderType: ''
            //         };
            //         this.editedItem.SplitType = {
            //             SplitTypeID: null,
            //             SplitTypeName: ''
            //         };
            //         this.editedItem.NoLoadType = {
            //             NoLoadTypeID: null,
            //             NoLoadTypeName: ''
            //         };
            //         this.$store.state.readings.dialog = false;
            //         this.$store.state.siteReadings.SiteNum = '';
            //         break;
            // }
        },
        editOrder: async function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            var params = {
                Station: this.editedItem.Station.id,
                Customer: this.editedItem.Customer.id,
                Terminal: this.editedItem.Terminal.id,
                Supplier: this.editedItem.Supplier.id,
                DateRequested: this.getMsk('DateRequested'),
                LoadingNumber: this.editedItem.LoadingNumber,
                SpecialInstructions: this.editedItem.SpecialInstructions,
                DispatchComments: this.editedItem.DispatchComments,
                SplitTypeID:
                    this.editedItem.SplitType == null
                        ? null
                        : this.editedItem.SplitType.SplitTypeID,
                OrderTypeID: this.editedItem.OrderType.OrderTypeID,
                NoLoadTypeID:
                    this.editedItem.NoLoadType === null
                        ? null
                        : this.editedItem.NoLoadType.NoLoadTypeID,
                ShipTo: this.editedItem.ShipTo,
                NoAllocation: this.editedItem.NoAllocation,
                isSpecific: this.Special,
                Validate: this.editedItem.Validate
            };
            if (this.type.id != 1) {
                params.RetainHrs = this.getMsk('RetainHrs');
                params.ROHrsTime = this.getMsk('ROHrsTime');
                params.ROHrsDate = this.getMsk('ROHrsDate');
                params.ROHrs = this.ROHrs;
            }
            await axios
                .put('order/' + this.orderID, params)
                .then(async response => {
                    this.editID = response.data.OrderID;
                    console.log(response.data);
                    if (this.editedItem.ShiftDetail == 0) {
                        this.$store.state.order.view = true;
                    }
                    await this.editOrderDetails(this.editID);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });

            console.log('Fin de la edici�n');
            this.$store.state.isLoading = false;

            if (this.editedItem.ShiftDetail > 0) {
                this.$emit('close', this.editedItem.ShiftDetail);
                this.$store.state.order.edt = false;
            }
        },
        editOrderDetails: async function(OrderID) {
            var str = this.$store;
            for (const i in this.orderProducts) {
                var orderDetailID = this.orderProducts[i].productDetailID;
                var params = {};
                console.log(orderDetailID);
                if (this.orderProducts[i].Product.ProductID != null) {
                    params = {
                        OrderID: OrderID,
                        ProductType: this.orderProducts[i].Product.ProductID,
                        ProductQuantity: this.orderProducts[i].Quantity,
                        DispatchedQuantity: this.orderProducts[i].Quantity,
                        ProductCode: this.orderProducts[i].ProductCode
                    };
                } else {
                    params = {
                        OrderID: OrderID,
                        ProductType: this.orderProducts[i].ProductID,
                        ProductQuantity: this.orderProducts[i].Quantity,
                        DispatchedQuantity: this.orderProducts[i].Quantity,
                        ProductCode: this.orderProducts[i].ProductCode
                    };
                }
                if (orderDetailID != undefined) {
                    console.log('Editing a new product', params);
                    await this.updateProductDetail(params, orderDetailID);
                } else {
                    console.log('Creating a new product', params);
                    await this.createProductDetail(params);
                }
            }
            if (this.deletedProducts.length > 0) {
                for (const j in this.deletedProducts) {
                    await axios
                        .delete('order-detail/' + this.deletedProducts[j], {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        })
                        .then(response => {
                            console.log(response);
                            str.dispatch('setSnackbar', {
                                color: 'success',
                                text: 'Changes saved successfully '
                            });
                        })
                        .catch(function(error) {
                            console.log(error);
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                }
            }
            this.$store.state.isLoading = false;
        },

        async createProductDetail(params) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            await axios
                .post('order-detail', params)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Changes saved successfully '
                    });
                    this.dialog = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },

        async updateProductDetail(params, id) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            await axios
                .put('order-detail/' + id, params)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Changes saved successfully '
                    });
                    this.dialog = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        copyOrder: function() {
            // create order copy
            var params = {
                OrderStatus: 'ACTIVE',
                Station: this.editedItem.Station.id,
                Customer: this.editedItem.Customer.id,
                Terminal: this.editedItem.Terminal.id,
                Supplier: this.editedItem.Supplier.id,
                DateRequested: this.editedItem.DateRequested,
                LoadingNumber: this.editedItem.LoadingNumber,
                SpecialInstructions: this.editedItem.SpecialInstructions,
                ReadyForDispatch: 1,
                isSpecific: this.Special
            };
            console.log(params);
            var newOrderID = 0;
            var str = this.$store;
            axios
                .post('order', params)
                .then(response => {
                    newOrderID = response.data.OrderID;
                    console.log('NewOrder', response.data);
                    console.log('NewOrder', newOrderID);
                    this.$store.state.order.view = true;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Successful Duplicate Order '
                    });

                    // create order details copy
                    axios
                        .get(
                            'order-detail/order/' +
                                this.$store.state.editedOrder.id,
                            {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            }
                        )
                        .then(response => {
                            for (const i in response.data.data) {
                                var params = {
                                    OrderID: newOrderID,
                                    ProductType:
                                        response.data.data[i].ProductID,
                                    ProductQuantity:
                                        response.data.data[i].Quantity,
                                    DispatchedQuantity:
                                        response.data.data[i].Quantity,
                                    ProductCode:
                                        response.data.data[i].ProductCode
                                };
                                axios
                                    .post('order-detail', params, {
                                        headers: {
                                            Authorization:
                                                'Bearer ' +
                                                this.$store.state.token
                                        }
                                    })
                                    .then(response => {
                                        console.log(response);
                                        this.$store.state.editedOrder.id = newOrderID;
                                    })
                                    .catch(function(error) {
                                        console.log(error);
                                        if (error.response.status === 403) {
                                            str.dispatch('setSnackbar', {
                                                color: 'error',
                                                text:
                                                    'You do not have the permission to use this function.'
                                            });
                                        }
                                        if (error.response.status === 500) {
                                            str.dispatch('setSnackbar', {
                                                color: 'error',
                                                text:
                                                    'An error has ocurred, please try again.'
                                            });
                                        }
                                    });
                            }
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        save: function() {
            if (this.orderID > 1) {
                this.dialog = true;
            } else {
                this.newOrder();
            }
        },
        async confirmDeleteOrder() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this order?',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteOrder();
            }
        },
        deleteOrder: function() {
            console.log(this.$store.state.editedOrder.id);
            console.log(this.$store.state.editedOrder);
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .delete('order/' + this.$store.state.editedOrder.id)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log(response);
                    this.$store.state.order.view = true;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order removed successfully.'
                    });

                    this.$store.state.order.view = true;

                    if (this.editedItem.ShiftDetail > 0) {
                        this.$emit('close', this.editedItem.ShiftDetail);
                        this.$store.state.order.edt = false;
                    } else {
                        this.$store.state.order.edt = false;
                    }
                })
                .catch(function(error) {
                    console.log(error.response);
                    console.log(error.response.status);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    if (error.response.status == 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Failed to delete order, already dispatched.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        cancel: function() {
            switch (this.$store.state.editedOrder.destiny) {
                case 1:
                    this.$store.state.editedOrder.id = null;
                    this.$store.state.editedOrder.destiny = null;
                    console.log('Aqui me fui 1461');
                    this.$router.push('/dispatch/orders');
                    break;
                case 2:
                    this.editedItem.SplitType = null;
                    this.editedItem.NoLoadType = null;
                    this.editedItem.OrderType = null;
                    this.$store.state.readings.dialog = false;
                    break;
            }
        },
        test: function() {
            console.log(this.$refs.siteRef.products);
        },
        checkArray(i) {
            console.log(i);
            console.log(this.orderProducts.Product);
        },
        checkSpecificTrailerOnly: async function() {
            for (const i in this.orderProducts) {
                console.log(this.orderProducts[i]);
                if (this.orderProducts[i].SpecificTrailerOnly == 1) {
                    this.Special = this.orderProducts[i].ProductID;
                }
                console.log(this.Special);
            }
        },
        async validate() {
            var str = this.$store;
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                if (
                    this.editedItem.Station.id == null ||
                    this.editedItem.Customer.id == null ||
                    this.editedItem.Terminal.id == null ||
                    this.editedItem.Supplier.id == null
                ) {
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Please make sure option is selected (Station, Terminal, Customer, Supolier)'
                    });
                } else {
                    await this.checkSpecificTrailerOnly();
                    if (this.type.id != 1) {
                        this.ROHrs = await this.calculateROHrs();
                    }
                    this.save();
                }
            }
        },
        async copyOrdCheck() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                await this.checkSpecificTrailerOnly();
                this.copyOrder();
            }
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        },
        getCode: function(item, idx) {
            console.log(item, this.orderProducts, idx);
            let productId = null;
            if (item.Product == []) {
                this.orderProducts[idx].SpecificTrailerOnly =
                    item.Product.SpecificTrailerOnly;
                this.orderProducts[idx].ProductID = item.Product.ProductID;
                productId = item.Product.ProductID;
            } else {
                this.orderProducts[idx].SpecificTrailerOnly = item.SpecificTrailerOnly;
                this.orderProducts[idx].ProductID = item.ProductID;
                productId = item.ProductID;
            }

            this.Special = 0;
            this.$store.state.isLoading = true;
            var params = {
                Customer: this.editedItem.Customer.id,
                Terminal: this.editedItem.Terminal.id,
                Supplier: this.editedItem.Supplier.id,
                Product: productId
            }
            console.log(item);
            axios
                .post('get-product-code-number', params)
                .then(response => {
                    console.log('Product code response: ', response.data);
                    this.orderProducts[idx].ProductCode = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        updateCodes: function() {
            // this.getLoadingNumber();
            if (this.orderProducts.length > 0) {
                this.orderProducts.forEach((element, i) => {
                    this.getCode(element, i);
                });
            }
        },
        replicateOrder:async function(){
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to duplicate this order?',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.orderID = 0;
                this.replicateOrd = true;
                this.editedItem.DateRequested = null;
                this.editedItem.RetainHrs = null;
                this.editedItem.ROHrsDate = null;
                this.editedItem.ROHrsTime = null;
                this.editedItem.OrderID = null;
            }
        },
        calculateRTHrs: function() {
            var mmt = moment().format('YYYY/MM/DD HH:mm');
            var roh = this.getMsk('DateRequested') + ' ' + this.getMsk('RetainHrs');
            var start = new Date(mmt);
            var end = new Date(roh);

            // Calcular la diferencia en milisegundos
            var diifMs = end - start;

            // Convertir la diferencia a horas
            var diifHrs = diifMs / (1000 * 60 * 60);

            return diifHrs.toFixed(2);
        },
        validateDuplicateOrder: async function(){
            var str = this.$store;
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                if (
                    this.editedItem.Station.id == null ||
                    this.editedItem.Customer.id == null ||
                    this.editedItem.Terminal.id == null ||
                    this.editedItem.Supplier.id == null
                ) {
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Please make sure option is selected (Station, Terminal, Customer, Supolier)'
                    });
                } else {
                    await this.checkSpecificTrailerOnly();
                    if (this.type.id != 1) {
                        this.ROHrs = await this.calculateROHrs();
                        this.RTHrs = await this.calculateRTHrs();
                    }
                    this.save();
                }
            }
        }
    }
};
</script>
<style>
.tm {
    width: 25%;
}

.tm12 {
    width: 12.5%;
}

.tm2 {
    width: 33.3%;
}

.tm3 {
    width: 15%;
}

.tm5 {
    width: 50%;
}

.tm35 {
    width: 35%;
}

.tm65 {
    width: 65%;
}

.pdr .v-text-field__details {
    display: none;
}

.pdr {
    font-size: 10px;
}
</style>
